import * as React from "react";
const CopyIcon = (props) => (
    <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_4484_4574)">
            <path
                d="M10.6666 8.60065V11.4007C10.6666 13.734 9.73325 14.6673 7.39992 14.6673H4.59992C2.26659 14.6673 1.33325 13.734 1.33325 11.4007V8.60065C1.33325 6.26732 2.26659 5.33398 4.59992 5.33398H7.39992C9.73325 5.33398 10.6666 6.26732 10.6666 8.60065Z"
                stroke="#008C95"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.6666 4.60065V7.40065C14.6666 9.73398 13.7333 10.6673 11.3999 10.6673H10.6666V8.60065C10.6666 6.26732 9.73325 5.33398 7.39992 5.33398H5.33325V4.60065C5.33325 2.26732 6.26658 1.33398 8.59992 1.33398H11.3999C13.7333 1.33398 14.6666 2.26732 14.6666 4.60065Z"
                stroke="#008C95"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_4484_4574">
                <rect width={16} height={16} fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export default CopyIcon;
